/**
 * Dev-only localStorage overrides — ignored in production builds.
 */

export function isDevOnlyUi() {
  return process.env.NODE_ENV === 'development';
}

export function getDevLoyaltyEnabledOverride() {
  if (process.env.NODE_ENV === 'production') {
    return null;
  }
  const value = localStorage.getItem('dev_loyalty_enabled');
  if (value === null) {
    return null;
  }
  return value === 'true';
}

export function isLoyaltyRecaptchaSkipped(apiBaseUrl = '') {
  if (process.env.NODE_ENV === 'production') {
    return false;
  }

  if (localStorage.getItem('force_dev_mode') === 'true') {
    return true;
  }

  if (process.env.NODE_ENV === 'development') {
    return true;
  }

  if (apiBaseUrl.includes('localhost') || apiBaseUrl.includes('127.0.0.1')) {
    return true;
  }

  if (typeof window !== 'undefined') {
    const host = window.location.hostname;
    if (host === 'localhost' || host === '127.0.0.1') {
      return true;
    }
  }

  return false;
}
